export default "__VITE_ASSET__7f100bdd__"